import { render, staticRenderFns } from "./table-answer-view.vue?vue&type=template&id=b26046ce&scoped=true"
import script from "./table-answer-view.vue?vue&type=script&lang=js"
export * from "./table-answer-view.vue?vue&type=script&lang=js"
import style0 from "./table-answer-view.vue?vue&type=style&index=0&id=b26046ce&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b26046ce",
  null
  
)

export default component.exports